module.exports = __webpack_public_path__ + "static/26-72dc6baf431d64930f6d976fcb55cf15.png";